import { LOGO } from './brand.js';
import { ico } from './icons.js';
import { av, isDark, me } from './selectors.js';
import { S, UI } from './store.js';
import { applyTheme } from './ui.js';
import { $, esc } from './util.js';
import { MODULES } from '../modules/index.js';

const ownerOf = (v) => MODULES.find((m) => m.id === v || (m.views && m.views[v]));

export function view() {
  const t = MODULES.find((m) => m.takeover && m.takeover.when());
  if (t) return t.takeover.view();
  const m = ownerOf(UI.v);
  if (!m) return '';
  const f = (m.views && m.views[UI.v]) || m.view;
  return f ? f() : '';
}

export function shell() {
  const u = me();
  const nav = MODULES.filter((m) => m.nav && (!m.show || m.show(u)));
  const owner = ownerOf(UI.v);
  return `<div class="app ${UI.nav ? 'navopen' : ''}">
  <aside class="side">
    <div class="brand"><img src="${LOGO.w}" alt="Render Media"></div>
    <nav aria-label="Main">${nav.map((m) => { const n = m.badge ? m.badge() : 0; return `<button class="nv ${owner === m ? 'on' : ''}" data-act="nav" data-v="${m.id}">${ico(m.icon)}<span>${m.label}</span>${n ? `<span class="bd">${n}</span>` : ''}</button>`; }).join('')}</nav>
    <div class="side-foot">
      <button class="nv" data-act="theme">${ico(isDark() ? 'sun' : 'moon')}<span>${isDark() ? 'Light mode' : 'Dark mode'}</span></button>
      <div class="who">${av(u.id, 34)}<div><b>${esc(u.name)}</b><small>${esc(u.title)}</small></div></div>
      <label class="viewas">Viewing as<select data-chg="setme">${S.users.filter((x) => x.active).map((x) => `<option value="${x.id}" ${x.id === S.me ? 'selected' : ''}>${esc(x.name)} (${x.role})</option>`).join('')}</select></label>
      <div class="proto">Phase 1 prototype with sample data. Changes save in this browser only.</div>
    </div>
  </aside>
  <div class="scrim" data-act="navclose"></div>
  <header class="mtop"><button class="ib" data-act="navtoggle" aria-label="Open menu">${ico('menu', 22)}</button><img src="${LOGO.w}" alt="Render Media"></header>
  <main class="main" id="main">${view()}</main></div>`;
}

export function render() {
  const main = $('#main');
  const sc = main ? main.scrollTop : 0;
  const keep = UI._keep;
  UI._keep = null;
  $('#app').innerHTML = shell();
  applyTheme();
  const m = $('#main');
  if (m) m.scrollTop = UI._top != null ? UI._top : sc;
  UI._top = null;
  MODULES.forEach((x) => x.afterRender && x.afterRender());
  if (keep) { const e = $(keep); if (e) e.focus(); }
}

export function go(v, extra) {
  UI.v = v; UI.aid = null; UI.cv = false; UI.pr = null;
  Object.assign(UI, extra || {});
  UI.nav = 0;
  if (UI.pl.h) { clearInterval(UI.pl.h); UI.pl.h = null; UI.pl.on = 0; }
  UI._top = 0;
  render();
}
